import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  Typography,
  Paper,
  MenuItem,
  IconButton,
  InputAdornment
} from "@mui/material";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import LayoutLandingHeader from '../components/LayoutLandingHeader';
import LayoutLandingFooter from '../components/LayoutLandingFooter';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import GSTLoader from '../components/GSTLoader';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ForgetPassword = () => {
  const [formData, setFormData] = useState({
    gstNumber: '',
    securityQuestion: '',
    securityAnswer: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [isValidated, setIsValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleValidation = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");

const res = await axios.post(
  `${BASE_URL}/Registration/ValidateSecurityAnswer`,
  {
    gstNumber: formData.gstNumber,
    securityQuestion: formData.securityQuestion,
    securityAnswer: formData.securityAnswer,
  },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);

      if (res.data.success) {
        setIsValidated(true);
      } else {
        alert("Invalid security answer or GST number.");
      }
    } catch (err) {
      console.error("Validation failed:", err);
      alert("Invalid security answer or GST number.");
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    try {
      const token = localStorage.getItem("token");

const res = await axios.put(
  `${BASE_URL}/Registration/ResetPasswordByGst`,
  {
    gstNumber: formData.gstNumber,
    password: formData.newPassword,
  },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
      if (res.data.success) {
        alert("Password updated successfully.");
        setIsValidated(false);
        setFormData({
          gstNumber: '',
          securityQuestion: '',
          securityAnswer: '',
          newPassword: '',
          confirmPassword: ''
        });
        navigate('/Login');
      } else {
        alert("Password update failed. Please try again.");
      }
    } catch (err) {
      console.error("Reset error:", err);
      alert("Password update failed. Please try again.");
    }
  };

  return (
    <GSTLoader>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundImage: 'url("Images/login.png")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        bgcolor: '#f5f6fa',
      }}>
        <LayoutLandingHeader />

        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2 }}>
          <Paper elevation={4} sx={{
            p: 6,
            borderRadius: 3,
            maxWidth: 500,
            width: '100%',
            textAlign: 'center',
            backgroundColor: 'rgba(255,255,255,0.9)',
          }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3, color: '#003366' }}>
              Forget Password
            </Typography>

            <form onSubmit={isValidated ? handlePasswordReset : handleValidation}>
              <TextField
                label="GST Number"
                name="gstNumber"
                value={formData.gstNumber}
                onChange={handleChange}
                required
                disabled={isValidated} // NON EDITABLE AFTER VALIDATION
                fullWidth
                sx={{ mb: 2 }}
              />

              {!isValidated && (
                <>
                  <TextField
                    select
                    label="Security Question"
                    name="securityQuestion"
                    value={formData.securityQuestion}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="Work Place">Work Place</MenuItem>
                    <MenuItem value="First Vehicle">First Vehicle</MenuItem>
                  </TextField>

                  <TextField
                    label="Security Answer"
                    name="securityAnswer"
                    value={formData.securityAnswer}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ mb: 3 }}
                  />
                </>
              )}

              {isValidated && (
                <>
                  <TextField
                    label="New Password"
                    name="newPassword"
                    type={showPassword ? 'text' : 'password'}
                    value={formData.newPassword}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ mb: 2 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />

                  <TextField
                    label="Confirm Password"
                    name="confirmPassword"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ mb: 3 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowConfirmPassword((prev) => !prev)} edge="end">
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </>
              )}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                {isValidated ? "Reset Password" : "Validate"}
              </Button>
            </form>
          </Paper>
        </Box>

        <LayoutLandingFooter />
      </Box>
    </GSTLoader>
  );
};

export default ForgetPassword;
